
import { Component, OnInit } from '@angular/core'
import { NotificationService } from '../../../../services/notification.service'
import { ActivatedRoute, Router } from '@angular/router'
import { OperationServiceService } from '../../../../services/operation.service.service'

import { Subject } from 'rxjs'
import { ISpecies } from 'src/app/models/Species'
import { debounceTime, distinctUntilChanged } from 'rxjs/operators'
import { CompanyService } from 'src/app/services/company.service'
import { getLoggedUser } from 'src/app/_helpers/LocalStorage'
import { InventoryService } from 'src/app/services/inventory.service'
import { InventoryDtoScheduling } from './dto/inventory-pre-scheduling.dto'
import { removeToolTip } from 'src/app/_helpers/Utils'
import { IHandlerOperation } from 'src/app/models/HandlerOperation'
import { HandlerOperationService } from 'src/app/services/handler.operation.service'
import { CompanyServiceProvider } from 'src/app/models/CompanyServiceProvider'
import { CompanyServiceProviderService } from 'src/app/services/company-service-provider'

@Component({
	selector: 'app-pre-scheduling-inventory',
	templateUrl: './pre-scheduling-inventory.component.html'
})
export class PreScheduleInventoryComponent implements OnInit {

	public companyId: string
	public inventoryIndex = 0
	public enableNextInventory: boolean = false
	public searchSpecieValue: string = ''
	public speciesSearchList: Array<ISpecies>
	public specieInPanel: boolean = true
	public srcImageSpecieSelected: string
	public speciesList: boolean = false
	public modalDetailsSpecie: boolean = false
	public isAdmin: boolean = false
	public ableToScheduleOperation: boolean = false
	public ableToScheduleAppraisal: boolean = false
	public ableToEditHandlerOperation: boolean = false
	public openActionSchedule: boolean = false
	public checkedActionOperation: boolean = false
	public checkedActionEvaluation: boolean = false
	public searchSpecie: Subject<string> = new Subject<string>()
	public editObservation: boolean = false
	public editingAnswerIndex: number = null
	public newObservation: string = ''
	public isLoading: boolean = false
	public cameFromScheduleMap: boolean = false
	public actualPage = 1
	public perPage = 10
	public sessionUser = getLoggedUser()
	public showSelectHandleOperations: boolean = false
	public showSelectCompanyProvider: boolean = false
	public handlerOperationsInventorySelected: Array<string> = []
	public handlerOperations: Array<IHandlerOperation> = []
	public companiesServiceProvider: Array<CompanyServiceProvider> = []

	constructor(
		public router: Router,
		public companyService: CompanyService,
		public inventoryService: InventoryService,
		public route: ActivatedRoute,
		public notificationService: NotificationService,
		public operationServiceService: OperationServiceService,
		public handlerOperationService: HandlerOperationService,
		private companyServiceProviderService: CompanyServiceProviderService
	) {
		this.searchSpecie.pipe(
			debounceTime(400),
			distinctUntilChanged())
			.subscribe(value => {
				this.onChangeSearch(value)
			})
	}

	public inventories: Array<InventoryDtoScheduling> = []
	public inventoriesTotal: number = 0

	private initialVersionOfInventories: Array<InventoryDtoScheduling> = []

	public ngOnInit() {
		this.isLoading = true
		this.isAdmin = getLoggedUser().roles.includes('GENERAL_ADMIN')
		this.companyId = localStorage.getItem('companyId')
		this.cameFromScheduleMap = Boolean(localStorage.getItem('cameFromScheduleMap') === 'true')
		this.fetchUserAssignments()

		this.getInventories(this.actualPage, this.perPage)
		this.getHandlerOperations()
		this.getCompaniesServiceProvider()
	}

	private getInventories(actualPage: number, perPage: number) {
		let inventoriesIds: Array<string> = JSON.parse(localStorage.getItem('inventories'))

		if (!this.cameFromScheduleMap) {
			const inventoriesLocalStorage = JSON.parse(localStorage.getItem('inventories'))
			inventoriesIds = inventoriesLocalStorage.map(inventory => inventory.idMongo)
		}

		this.operationServiceService.getInventoriesSchedule(inventoriesIds, actualPage, perPage).subscribe(result => {
			this.inventories = [...this.inventories, ...result.inventories]
			this.inventoriesTotal = result.countInventories
			this.initialVersionOfInventories = [...this.initialVersionOfInventories, ...JSON.parse(JSON.stringify(result.inventories))]
			this.setHandleOperationsInventorySelected()
		}, err => {
			console.log(err, 'Erro ao buscar inventários')
		}, () => {
			this.isLoading = false
		})
	}

	public async getCompaniesServiceProvider(): Promise<void> {
		try {
			this.companiesServiceProvider =
				await this.companyServiceProviderService.getCompaniesServiceProvider({
					companyId: this.companyId,
					skip: 0,
					limit: 100,
					order: 'CNPJ',
					typeOrder: 'desc'
				}).toPromise()
		} catch (err) {
			this.notificationService.notify(err.error.message, err.error.statusCode || 400)
		}
	}

	public removeSpecieList() {
		this.speciesList = false
	}

	public async back() {
		this.router.navigate(['/panel/inventory/schedulerInventory'])
		localStorage.removeItem('inventories')
		localStorage.removeItem('cameFromScheduleMap')
	}

	public scrollUp() {
		const steps: HTMLDivElement = document.getElementById('main') as HTMLDivElement

		steps.scrollIntoView({
			behavior: 'smooth'
		})
	}

	public previousInventory() {
		if (this.inventoryIndex > 0) {
			this.inventoryIndex--

			this.scrollUp()
			this.setHandleOperationsInventorySelected()
		}
	}

	public nextInventory() {
		if (
			this.inventoryIndex < this.inventories.length - 1
		) {
			this.inventoryIndex++

			this.scrollUp()
		}

		if (this.inventoryIndex === this.inventories.length - 2 && this.inventories.length < this.inventoriesTotal) {
			this.getInventories(this.actualPage + 1, this.perPage)

			this.setHandleOperationsInventorySelected()
		}
	}

	public fetchUserAssignments(): void {
		const userHasPermissionToUpdateHandlerOperation: boolean =
			this.sessionUser.assignments.includes('INVENTORY_PRE_SCHEDULE_HANDLER_OPERATION_UPDATE')

		this.ableToEditHandlerOperation = userHasPermissionToUpdateHandlerOperation || this.sessionUser.roles.includes('GENERAL_ADMIN')

		this.companyService.getCompanyModuleAssignments(this.companyId).subscribe((data: Array<{
			moduleName: string;
			subModules: Array<{
				name: string;
				assignments: Array<{
					name: string;
					readableName: string;
					description: string;
				}>;
			}>;
		}>) => {
			this.ableToScheduleAppraisal = Boolean(
				data.some(module => module.moduleName === 'Avaliação')
			)

			this.ableToScheduleOperation = Boolean(
				data.some(module => module.moduleName === 'Manejo')
			)
		})
	}

	public toggleModalActionSchedule() {
		this.checkedActionEvaluation = false
		this.checkedActionOperation = false

		this.openActionSchedule = !this.openActionSchedule
	}

	public selectedActionSchedule(typeAction: 'operation' | 'evaluation') {

		if (typeAction == 'operation') {
			this.checkedActionEvaluation = false
			this.checkedActionOperation = true
		} else {
			this.checkedActionEvaluation = true
			this.checkedActionOperation = false
		}
	}

	public openSelectCompanyProvider() {
		if (this.companiesServiceProvider.length === 1) {
			this.conclusion(this.companiesServiceProvider[0].idMongo)
		} else {
			this.showSelectCompanyProvider = true
		}
	}

	public closeSelectCompanyProvider() {
		this.showSelectCompanyProvider = false
	}

	public selectCompanyProvider(companyProvider: CompanyServiceProvider) {
		this.closeSelectCompanyProvider()
		this.conclusion(companyProvider.idMongo)
	}

	public conclusion(companyProviderId?: string) {
		let inventoriesModified: Array<InventoryDtoScheduling> = this.inventoriesWithChanges(this.inventories)

		inventoriesModified = JSON.parse(JSON.stringify(inventoriesModified.map(inventory => {
			delete inventory.specieSelected
			return inventory
		})))

		this.notificationService.initLoading()
		this.inventoryService.updateInventoriesFromScheduler(inventoriesModified).subscribe(() => {
			if (this.checkedActionEvaluation) {
				this.router.navigate(['/panel/appraisal/evaluation/steps'])
			} else if (this.checkedActionOperation) {
				this.sendToOperationSchedule(companyProviderId).subscribe(response => {
					this.notificationService.notify(response, 200)
					this.notificationService.stopLoading()
					this.router.navigate(['/panel/management/operationService'])
				}, err => {
					this.notificationService.notify('Erro ao criar Manejo!', 500)
					console.log(err, 'Erro ao enviar para o agendamento')
					this.notificationService.stopLoading()
				})
			} else {
				this.notificationService.notify('Selecione uma ação!', 420)
			}
		})
	}

	public compareInventories(initialInventory: InventoryDtoScheduling, beforeInventory: InventoryDtoScheduling): boolean {
		const editableFields = [
			'categoryAddress',
			'addressReference',
			'treeIdentifier',
			'observation',
			'height',
			'cupProjection',
			'specialValue',
			'fusteHeight',
			'dapCap',
			'dapCapValue',
			'specieId',
			'inventorAnswers',
			'handlerOperations'
		]

		for (const field of editableFields) {
			if (JSON.stringify(initialInventory[field]) !== JSON.stringify(beforeInventory[field])) {
				return false
			}
		}

		return true
	}

	public inventoriesWithChanges(currentInventories: Array<InventoryDtoScheduling>): Array<any> {
		const inventoriesWithChanges = []

		for (let i = 0; i < this.initialVersionOfInventories.length; i++) {
			const initialInventory = this.initialVersionOfInventories[i]
			const currentInventory = currentInventories[i]

			if (!this.compareInventories(initialInventory, currentInventory)) {
				inventoriesWithChanges.push(currentInventory)
			}
		}

		return inventoriesWithChanges
	}

	public sendToOperationSchedule(companyProviderId: string) {
		let inventoriesIds: Array<string> = JSON.parse(localStorage.getItem('inventories'))

		if (!this.cameFromScheduleMap) {
			const inventoriesLocalStorage = JSON.parse(localStorage.getItem('inventories'))
			inventoriesIds = inventoriesLocalStorage.map(inventory => inventory.idMongo)
		}

		return this.inventoryService.sendToOperationSchedule(this.companyId, companyProviderId, inventoriesIds)
	}

	public openCloseModalDetailsSpecie() {
		this.modalDetailsSpecie = !this.modalDetailsSpecie
	}

	public disableConclusion() {
		return this.inventories.every(inventory => {
			return (
				inventory.height !== 0 &&
				inventory.fusteHeight !== 0 &&
				inventory.cupProjection !== 0 &&
				inventory.dapCapValue !== 0 &&
				inventory.dapCapValue !== null &&
				inventory.fusteHeight !== undefined &&
				inventory.fusteHeight !== 0 &&
				inventory.handlerOperations.length > 0
			)
		})
	}

	public disableNextInventory() {
		if (
			this.inventories[this.inventoryIndex].height !== 0 &&
			this.inventories[this.inventoryIndex].fusteHeight !== 0 &&
			this.inventories[this.inventoryIndex].cupProjection !== 0 &&
			this.inventories[this.inventoryIndex].dapCapValue !== 0 &&
			this.inventories[this.inventoryIndex].dapCapValue !== null &&
			this.inventories[this.inventoryIndex].fusteHeight !== undefined &&
			this.inventories[this.inventoryIndex].fusteHeight !== 0
		) {
			return false
		} else {
			return true
		}
	}

	public selectSpecie(specie: ISpecies) {
		this.srcImageSpecieSelected = this.inventories[this.inventoryIndex].specieSelected.gallery[0]

		this.speciesList = false
		this.specieInPanel = true

		this.inventories[this.inventoryIndex].specieSelected = specie

		this.searchSpecieValue = ''
	}

	public onChangeInputMensurament(event: { fieldName: string, value: number }) {
		if (event.fieldName == 'height') {
			this.inventories[this.inventoryIndex].height = event.value
		}
		if (event.fieldName == 'cupProjection') {
			this.inventories[this.inventoryIndex].cupProjection = event.value
		}
		if (event.fieldName == 'fusteHeight') {
			this.inventories[this.inventoryIndex].fusteHeight = event.value
		}
		if (event.fieldName == 'dapCap') {
			this.inventories[this.inventoryIndex].dapCap = String(event.value)
		}
		if (event.fieldName == 'dapCapValue') {
			this.inventories[this.inventoryIndex].dapCapValue = event.value
		}
	}

	public async onChangeSearch(valueSearch: string) {
		try {
			if (!valueSearch.trim() || valueSearch.trim().length < 2) {
				return
			}

			this.operationServiceService.getSpecies({ filter: valueSearch }).subscribe(result => {
				this.speciesSearchList = result.content
				this.speciesList = true
			})

		} catch (error) {
			console.log(error, 'Erro ao buscar espécies')
		}
	}

	public editInventorAnswerObservations(index: number) {
		this.editObservation = true
		this.editingAnswerIndex = index
		this.newObservation = this.inventories[this.inventoryIndex].inventorAnswers[index].other || ''
		removeToolTip()
	}

	public saveObservation() {
		this.inventories[this.inventoryIndex]
			.inventorAnswers[this.editingAnswerIndex]
			.other = this.newObservation

		this.newObservation = ''
		this.editObservation = false
		this.editingAnswerIndex = null
		removeToolTip()
	}

	public cancelEdit() {
		this.newObservation = ''
		this.editObservation = false
		this.editingAnswerIndex = null
		removeToolTip()
	}

	public async getHandlerOperations(): Promise<void> {
		const handleOperations: Array<IHandlerOperation> =
			await this.handlerOperationService.list(this.companyId, false, 'Inventor').toPromise()

		const operations = handleOperations.map(item => {
			return {
				operation: item.operation,
				_id: item._id
			}
		})

		this.handlerOperations = operations
	}

	public openSelectorHandlerOperations() {
		this.showSelectHandleOperations = true
	}

	public setHandleOperationsInventorySelected() {
		const handlerOperations: Array<string> = []

		this.inventories[this.inventoryIndex].handlerOperations.forEach(operations => {
			handlerOperations.push(operations.operation)
		})

		this.handlerOperationsInventorySelected = handlerOperations
	}

	public closeSelectorHandlerOperations(
		event: Array<{
			idMongo: string,
			operation: string
		}>
	) {
		this.showSelectHandleOperations = false
		this.inventories[this.inventoryIndex].handlerOperations = event
		this.setHandleOperationsInventorySelected()
	}
}
